// Pure client-side decisions for the friend battle screen, kept free of React
// and browser globals so they can be tested directly.
// One chart preference shared by the solo game and friend battles.
export const CHART_MODE_KEY = "gaemitalk.chart";
type ChartStorage = Pick<Storage, "getItem" | "setItem">;
type Effect = { id: number; player: string; reaction: string };

// Private browsing can block storage; the toggle then simply lasts one screen.
export function readCandles(storage: () => ChartStorage) {
  try {
    return storage().getItem(CHART_MODE_KEY) === "candles";
  } catch {
    return false;
  }
}
export function writeCandles(storage: () => ChartStorage, candles: boolean) {
  try {
    storage().setItem(CHART_MODE_KEY, candles ? "candles" : "line");
  } catch {
    // Storage is optional.
  }
}

// Effects already in the room on arrival (seen === null) are old news, our own
// presses were drawn immediately, and repeated polls must not replay an effect.
export function freshEffects(
  seen: number | null,
  effects: Effect[],
  me?: string,
) {
  return {
    fresh:
      seen === null
        ? []
        : effects.filter((e) => e.id > seen && e.player !== me),
    seen: Math.max(seen ?? 0, ...effects.map((e) => e.id)),
  };
}

// A requester follows the host only when the rematch lobby opens while they
// wait on the finished room; `join` asks the server to confirm their seat first.
export function rematchStep(
  awaiting: boolean,
  room: { state: string; next?: string | null; requested: boolean },
) {
  if (room.state !== "completed") return { awaiting, join: false };
  if (!room.next) return { awaiting: room.requested, join: false };
  return { awaiting: false, join: awaiting };
}
